 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		7: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		7: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"faf982d37fe5ec0101a14952969f6fb6407c39a0","1":"518e6421012d1ff3722832c8d56a474157d9e021","2":"943c0d5494292b97a917d224bfb63c7d68e6ffcb","3":"3097f2165675c14ec4bc71c6ece3882dc0eaeaa4","4":"8c0d8845c39b9fc8a6e4e2454b05899e8645452d","5":"f327ec71549ff14f6d6f108d57320fccb1ed1475","6":"styles","12":"component---src-pages-about-js","13":"component---src-pages-academy-elearning-js","14":"component---src-pages-academy-js","15":"component---src-pages-admin-audit-js","16":"component---src-pages-admin-js","17":"component---src-pages-admin-paths-js","18":"component---src-pages-admin-projects-js","19":"component---src-pages-agency-1-js","20":"component---src-pages-agency-2-js","21":"component---src-pages-career-path-js","22":"component---src-pages-contact-js","23":"component---src-pages-designer-2-js","24":"component---src-pages-devloper-1-js","25":"component---src-pages-devloper-2-js","26":"component---src-pages-examples-js","27":"component---src-pages-grid-2-js","28":"component---src-pages-grid-3-fluid-js","29":"component---src-pages-grid-3-js","30":"component---src-pages-grid-4-fluid-js","31":"component---src-pages-grid-4-js","32":"component---src-pages-how-we-work-js","33":"component---src-pages-index-js","34":"component---src-pages-infrastructure-js","35":"component---src-pages-lab-js","36":"component---src-pages-labs-js","37":"component---src-pages-login-js","38":"component---src-pages-masonry-2-column-js","39":"component---src-pages-masonry-3-column-fluid-js","40":"component---src-pages-masonry-3-column-js","41":"component---src-pages-masonry-4-column-fluid-js","42":"component---src-pages-masonry-4-column-js","43":"component---src-pages-newsletter-js","44":"component---src-pages-notifications-js","45":"component---src-pages-p-js","46":"component---src-pages-patterns-js","47":"component---src-pages-photography-1-js","48":"component---src-pages-photography-2-js","49":"component---src-pages-portfolio-details-2-js","50":"component---src-pages-portfolio-details-js","51":"component---src-pages-pricing-js","52":"component---src-pages-profile-js","53":"component---src-pages-proposal-js","54":"component---src-pages-sales-dashboard-js","55":"component---src-pages-sales-js","56":"component---src-pages-sales-leads-js","57":"component---src-pages-slack-js","58":"component---src-pages-staffing-js","59":"component---src-pages-team-js","60":"component---src-pages-time-tracker-js","61":"component---src-pages-tools-js","62":"component---src-pages-unsubscribe-js","63":"component---src-templates-elearning-module-js","64":"component---src-templates-opening-detail-js","65":"component---src-templates-pattern-detail-js","68":"reactPlayerDailyMotion","69":"reactPlayerFacebook","70":"reactPlayerFilePlayer","71":"reactPlayerKaltura","72":"reactPlayerMixcloud","73":"reactPlayerPreview","74":"reactPlayerSoundCloud","75":"reactPlayerStreamable","76":"reactPlayerTwitch","77":"reactPlayerVidyard","78":"reactPlayerVimeo","79":"reactPlayerWistia","80":"reactPlayerYouTube"}[chunkId]||chunkId) + "-" + {"0":"7c3cd136fb416136dab8","1":"2f933bc7abea8089818a","2":"fff151f9b6772b75936a","3":"2fb40e6d7c0812e9b0dd","4":"8d649762ad93bdef7841","5":"291c55be094edc9e587b","6":"001ae6ded9fe131102a4","12":"8e7abe68366e83ef8fc4","13":"7dc99a2527ffb256b465","14":"75a380b8d8ed31c3c3c2","15":"b3451e563c1e6c9d9c5b","16":"7fd34fe0da1aed086e79","17":"1a4a1b4bd775f22f5630","18":"eb39bf43b599ecee873c","19":"a2c29697e6526ea4e1ab","20":"a2504610576ed5a6dddf","21":"c51c78b14b427a93495b","22":"2ac7b72bc7f978b21d67","23":"f22141226da1413b0d89","24":"48e3163106642fb209b9","25":"a408c529a8a107acf6ae","26":"3a72882d448d7c0d24e4","27":"9d15612a4db2e0e2a350","28":"1abc29824a0c0f00f4a0","29":"4b8b7b05fb99a853782a","30":"b7ed4cffa94a8fbb48c8","31":"7e24c1e0317959ff81e7","32":"71ca26cefa1e8c05bea1","33":"3217c4a1ee342be17764","34":"14886e5e5480ce42d13b","35":"1784e25127d12b2c33fc","36":"b49a78bc682482371823","37":"4fab20df008bf98b47bd","38":"9a652b966baa40c322a6","39":"8ca4cc5e17207c9fb2a9","40":"70145600cf09845abbd0","41":"3ac6f78a74b6641e9455","42":"87f0027bbfcf2c17c522","43":"10c848cd35dd8020ff2b","44":"08852c11500dd748cd9e","45":"f3c371ecfaf635eaafd5","46":"1c17a2738087c34a2ee1","47":"dabb28150286b9671637","48":"5eb883ab866199ef6230","49":"70983a7b862e4f609e44","50":"f7b98cef444f4ad5581e","51":"e0756a5a8e926dafbfe0","52":"da0fb8bb1d9391fcf73e","53":"2ee4118deedc889eeebc","54":"aaeb4c4833656145ec58","55":"d66b68d90895d9266e0d","56":"da41fa8f741265a7eb5e","57":"b8cc9c6d1b7e6490d283","58":"5228b25b5655b159793e","59":"e0c6e5543da8bad72e2f","60":"ff7f3c4a7da02031d544","61":"1d4520961ad0c6d0c17f","62":"c6cf3e794b5789c32b85","63":"50ce87ca0488c11d03d9","64":"03040b26da20c3468c9e","65":"59e981c813295331ce10","68":"e54a94e2f9e053915ad6","69":"1b49d446080c1c4e9f27","70":"ff74f81cc39712816980","71":"2cdbcfcaea844b3d1675","72":"5b5de853d8a71cea7eda","73":"a2a045e02707119aa043","74":"871bda2d93dc7549cf1a","75":"351943c6652052d641e6","76":"b0fd8e7a1ee0df505f1c","77":"23d7adb82f949713af7d","78":"6f835de343fc3c938639","79":"783f4093d1600c3d2486","80":"0a95843fac24f37299c0","81":"b6090b9db1e85337d403","82":"d3036756a723cebf1011","83":"feb1d0530586f8b4aba5","84":"8f1ad2216fdde052f251","85":"59133bff242c73f8ebcb","86":"bf91c7d5bc2e41ef7d1f"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"6":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"faf982d37fe5ec0101a14952969f6fb6407c39a0","1":"518e6421012d1ff3722832c8d56a474157d9e021","2":"943c0d5494292b97a917d224bfb63c7d68e6ffcb","3":"3097f2165675c14ec4bc71c6ece3882dc0eaeaa4","4":"8c0d8845c39b9fc8a6e4e2454b05899e8645452d","5":"f327ec71549ff14f6d6f108d57320fccb1ed1475","6":"styles","12":"component---src-pages-about-js","13":"component---src-pages-academy-elearning-js","14":"component---src-pages-academy-js","15":"component---src-pages-admin-audit-js","16":"component---src-pages-admin-js","17":"component---src-pages-admin-paths-js","18":"component---src-pages-admin-projects-js","19":"component---src-pages-agency-1-js","20":"component---src-pages-agency-2-js","21":"component---src-pages-career-path-js","22":"component---src-pages-contact-js","23":"component---src-pages-designer-2-js","24":"component---src-pages-devloper-1-js","25":"component---src-pages-devloper-2-js","26":"component---src-pages-examples-js","27":"component---src-pages-grid-2-js","28":"component---src-pages-grid-3-fluid-js","29":"component---src-pages-grid-3-js","30":"component---src-pages-grid-4-fluid-js","31":"component---src-pages-grid-4-js","32":"component---src-pages-how-we-work-js","33":"component---src-pages-index-js","34":"component---src-pages-infrastructure-js","35":"component---src-pages-lab-js","36":"component---src-pages-labs-js","37":"component---src-pages-login-js","38":"component---src-pages-masonry-2-column-js","39":"component---src-pages-masonry-3-column-fluid-js","40":"component---src-pages-masonry-3-column-js","41":"component---src-pages-masonry-4-column-fluid-js","42":"component---src-pages-masonry-4-column-js","43":"component---src-pages-newsletter-js","44":"component---src-pages-notifications-js","45":"component---src-pages-p-js","46":"component---src-pages-patterns-js","47":"component---src-pages-photography-1-js","48":"component---src-pages-photography-2-js","49":"component---src-pages-portfolio-details-2-js","50":"component---src-pages-portfolio-details-js","51":"component---src-pages-pricing-js","52":"component---src-pages-profile-js","53":"component---src-pages-proposal-js","54":"component---src-pages-sales-dashboard-js","55":"component---src-pages-sales-js","56":"component---src-pages-sales-leads-js","57":"component---src-pages-slack-js","58":"component---src-pages-staffing-js","59":"component---src-pages-team-js","60":"component---src-pages-time-tracker-js","61":"component---src-pages-tools-js","62":"component---src-pages-unsubscribe-js","63":"component---src-templates-elearning-module-js","64":"component---src-templates-opening-detail-js","65":"component---src-templates-pattern-detail-js","68":"reactPlayerDailyMotion","69":"reactPlayerFacebook","70":"reactPlayerFilePlayer","71":"reactPlayerKaltura","72":"reactPlayerMixcloud","73":"reactPlayerPreview","74":"reactPlayerSoundCloud","75":"reactPlayerStreamable","76":"reactPlayerTwitch","77":"reactPlayerVidyard","78":"reactPlayerVimeo","79":"reactPlayerWistia","80":"reactPlayerYouTube"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"d93bb23495ae68b4f7e6","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c","58":"31d6cfe0d16ae931b73c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"31d6cfe0d16ae931b73c","62":"31d6cfe0d16ae931b73c","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"31d6cfe0d16ae931b73c","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"31d6cfe0d16ae931b73c","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c","74":"31d6cfe0d16ae931b73c","75":"31d6cfe0d16ae931b73c","76":"31d6cfe0d16ae931b73c","77":"31d6cfe0d16ae931b73c","78":"31d6cfe0d16ae931b73c","79":"31d6cfe0d16ae931b73c","80":"31d6cfe0d16ae931b73c","81":"31d6cfe0d16ae931b73c","82":"31d6cfe0d16ae931b73c","83":"31d6cfe0d16ae931b73c","84":"31d6cfe0d16ae931b73c","85":"31d6cfe0d16ae931b73c","86":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
